import { useState } from "react";
import { MainContent } from "./MainContent";
import { Header } from "./Header";
import { BottomNav } from "./BottomNav";
import { useLayoutStore } from "@/stores/useLayoutStore";
import { useAuth } from "@/contexts/AuthContext";
import { ROLES } from "@/common/permissions";
import { useHasDashboardAccess } from "@/hooks/useHasDashboardAccess";
import { DASHBOARD_HOME_ROUTE } from "@/common/routes.common";

interface RootLayoutProps {
  showChargeButton?: boolean;
}

export function RootLayout({ showChargeButton = true }: RootLayoutProps) {
  const [isOpen, setIsOpen] = useState(false);
  const hideBottomNav = useLayoutStore((state) => state.hideBottomNav);
  const { signOut } = useAuth();
  const hasDashboardAccess = useHasDashboardAccess();

  const navigation = [
    ...(hasDashboardAccess ? [{ name: "navigation.dashboard", href: DASHBOARD_HOME_ROUTE }] : []),
    //{ name: "navigation.settings", href: "/settings" },
    { name: "navigation.support", href: "/support", role: ROLES.MANAGER },
    { name: "navigation.policies", href: "/policies" },
    { name: "navigation.logout", onClick: signOut },
  ];

  return (
    <div className="min-h-screen bg-dark">
      <div className="max-w-md md:max-w-none lg:max-w-none xl:max-w-md mx-auto h-full">
        <Header isOpen={isOpen} setIsOpen={setIsOpen} navigation={navigation} />
        <MainContent />
        {!hideBottomNav && (
          <BottomNav
            showChargeButton={showChargeButton}
            className="mx-auto max-w-md md:max-w-none lg:max-w-none xl:max-w-md xl:px-[0.5rem]"
          />
        )}
      </div>
    </div>
  );
}
